import React, { createContext, useContext, useState } from "react";
import CustomToast from "../component/utils/CustomToast";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState(null);

    return (
        <ToastContext.Provider value={{ toast, setToast }}>
            {children}
            {toast && <CustomToast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);